<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Header - Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Manage Team</span>
        <h3 class="page-title">Members</h3>
      </d-col>
    </d-row>
    <!-- Team Members -->
    <d-row class="my-4">
      <d-col v-for="member in members" :key="member.member" lg="5" sm="12">
        <d-col class="card-max-400" lg="5" sm="12">
          <up-user-details/>
          <up-user-contact/>
        </d-col>
      </d-col>
    </d-row>
    <!-- End Team Members -->
  </d-container>
</template>

<script>
import UserDetails from "@/components/user-profile/UserDetails.vue";

export default {
  name: "user-profile",
  components: {
    upUserDetails: UserDetails
  }
};
</script>
